import { FaArrowUp, FaClock, FaGraduationCap, FaSeedling, FaUsers } from 'react-icons/fa';

const careerIntro = {
    subKey: "career.intro.sub",
    headingKey: "career.intro.heading",
    descriptionKey: "career.intro.description",
    pointsKeys: [
        'career.intro.points.0',
        'career.intro.points.1',
        'career.intro.points.2',
        'career.intro.points.3',
        'career.intro.points.4',
        'career.intro.points.5'
    ],
}

const positions = [];

const benefits = [
    {
        id: 1,
        titleKey: 'career.benefits.1.title',
        descriptionKey: 'career.benefits.1.description',
        icon: <FaSeedling />
    },
    {
        id: 5,
        titleKey: 'career.benefits.5.title',
        descriptionKey: 'career.benefits.5.description',
        icon: <FaUsers />
    },
    {
        id: 3,
        titleKey: 'career.benefits.3.title',
        descriptionKey: 'career.benefits.3.description',
        icon: <FaArrowUp />
    },
    {
        id: 4,
        titleKey: 'career.benefits.4.title',
        descriptionKey: 'career.benefits.4.description',
        icon: <FaClock />
    },
    {
        id: 2,
        titleKey: 'career.benefits.2.title',
        descriptionKey: 'career.benefits.2.description',
        icon: <FaGraduationCap />
    },
    {
        id: 6,
        titleKey: 'career.benefits.6.title',
        descriptionKey: 'career.benefits.6.description',
        icon: <FaArrowUp />
    },
];

const sampleTasksKeys = [
    "career.tasks.0",
    "career.tasks.1",
    "career.tasks.2",
    "career.tasks.3",
    "career.tasks.4",
    "career.tasks.5",
    "career.tasks.6"
];

export { positions, benefits, careerIntro, sampleTasksKeys };